export enum TargetSystem {
  AssetManagement = 'AssetManagement',
  CoreApi = 'CoreApi',
  Core = 'Core'
}

export const enum AccessArea {
  Administrator = 'Administrator',
  Project = 'ProjectsModule',
  Product = 'ProductSponsor',
  AssetManagement = 'AssetManagement',
  BulkPayment = 'BulkPayment',
  SystemAdministrator = 'UnifiiAdmin'
}

export const enum AccessRight {
  Executive = 'Executive',
  ViewOnly = 'ViewOnly',
  Basic = 'Basic',
  ViewAll = 'ViewAll'
}

export enum FieldState {
  Ok = 'ok',
  Error = 'error'
}

